import React from "react";

const CreateGroup = () => {
  return <div>CreateGroup</div>;
};

export default CreateGroup;
